import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"

export enum Ecig101Assets {
    INTRO_SCENE = "Ecig101INTRO_SCENE",
    PACK_CIGARETTES = "Ecig101PACK_CIGARETTES",
    ECIGS = "Ecig101ECIGS",
    CARTRIDGE = "Ecig101CARTRIDGE",
    MOUTH_PIECE = "Ecig101MOUTH_PIECE",
    HEATING_ELEMENT = "Ecig101HEATING_ELEMENT",
    BATTERY = "Ecig101BATTERY",
    ECIG_TYPES = "Ecig101ECIG_TYPES",
    ELIQUIDS = "Ecig101ELIQUIDS",

    // Sprites
    VAPE_PEN = "Ecig101VAPE_PEN",
    MATCH = "Ecig101MATCH",
    LIGHTABLE_CIGARETTE = "Ecig101LIGHTABLE_CIGARETTE",
    VAPE_MOD = "Ecig101VAPE_MOD",

    VAPE_PEN_SILHOUETTE_1 = "Ecig101VAPE_PEN_SILHOUETTE_1",
    VAPE_PEN_SILHOUETTE_2 = "Ecig101VAPE_PEN_SILHOUETTE_2",
    VAPE_PEN_SILHOUETTE_3 = "Ecig101VAPE_PEN_SILHOUETTE_3",
    VAPE_PEN_SILHOUETTE_4 = "Ecig101VAPE_PEN_SILHOUETTE_4",
    VAPE_SILHOUETTE_1 = "Ecig101VAPE_SILHOUETTE_1",
    VAPE_SILHOUETTE_2 = "Ecig101VAPE_SILHOUETTE_2",
    VAPE_SILHOUETTE_3 = "Ecig101VAPE_SILHOUETTE_3",
    VAPE_SILHOUETTE_4 = "Ecig101VAPE_SILHOUETTE_4",
    VAPE_SILHOUETTE_5 = "Ecig101VAPE_SILHOUETTE_5",

    // Audio enum values below here
    INTRO_AUDIO = "Ecig101INTRO_AUDIO",
    BATTERY_AUDIO = "Ecig101BATTERY_AUDIO",
    CARTRIDGE_AUDIO = "Ecig101CARTRIDGE_AUDIO",
    HEATING_ELEMENT_AUDIO = "Ecig101HEATING_ELEMENT_AUDIO",
    MOUTH_PIECE_AUDIO = "Ecig101MOUTH_PIECE_AUDIO",
    ECIG_POWER_AUDIO = "Ecig101ECIG_POWER_AUDIO",
    ECIG_POWER_AUDIO_6TH = "Ecig101ECIG_POWER_AUDIO_6TH",
    ELIQUIDS_AUDIO = "Ecig101ELIQUIDS_AUDIO",
    ELIQUIDS_AUDIO_6TH = "Ecig101ELIQUIDS_AUDIO_6TH",
    EXIT_AUDIO = "Ecig101EXIT_AUDIO",

}

export function loadAssets(game: Phaser.Game) {
    game.load.image(Ecig101Assets.INTRO_SCENE, CCUtils.asset("ecig-101/opening-screen.png"))
    game.load.image(Ecig101Assets.PACK_CIGARETTES, CCUtils.asset("ecig-101/pack-cigarettes.png"))
    game.load.image(Ecig101Assets.ECIGS, CCUtils.asset("ecig-101/ecigs.png"))
    game.load.image(Ecig101Assets.CARTRIDGE, CCUtils.asset("ecig-101/cartridge.png"))
    game.load.image(Ecig101Assets.MOUTH_PIECE, CCUtils.asset("ecig-101/mouth-piece.png"))
    game.load.image(Ecig101Assets.HEATING_ELEMENT, CCUtils.asset("ecig-101/heating-element.png"))
    game.load.image(Ecig101Assets.BATTERY, CCUtils.asset("ecig-101/battery.png"))
    game.load.image(Ecig101Assets.ECIG_TYPES, CCUtils.asset("ecig-101/ecig-types.png"))
    game.load.image(Ecig101Assets.ELIQUIDS, CCUtils.asset("ecig-101/e-liquids.png"))

    // This is too big for a sprite.
    game.load.image(Ecig101Assets.VAPE_PEN_SILHOUETTE_1, CCUtils.asset("ecig-101/vape-pen-silhouette-1.png"))
    game.load.image(Ecig101Assets.VAPE_PEN_SILHOUETTE_2, CCUtils.asset("ecig-101/vape-pen-silhouette-2.png"))
    game.load.image(Ecig101Assets.VAPE_PEN_SILHOUETTE_3, CCUtils.asset("ecig-101/vape-pen-silhouette-3.png"))
    game.load.image(Ecig101Assets.VAPE_PEN_SILHOUETTE_4, CCUtils.asset("ecig-101/vape-pen-silhouette-4.png"))
    game.load.image(Ecig101Assets.VAPE_SILHOUETTE_1, CCUtils.asset("ecig-101/vape-silhouette-1.png"))
    game.load.image(Ecig101Assets.VAPE_SILHOUETTE_2, CCUtils.asset("ecig-101/vape-silhouette-2.png"))
    game.load.image(Ecig101Assets.VAPE_SILHOUETTE_3, CCUtils.asset("ecig-101/vape-silhouette-3.png"))
    game.load.image(Ecig101Assets.VAPE_SILHOUETTE_4, CCUtils.asset("ecig-101/vape-silhouette-4.png"))
    game.load.image(Ecig101Assets.VAPE_SILHOUETTE_5, CCUtils.asset("ecig-101/vape-silhouette-5.png"))

    game.load.spritesheet(Ecig101Assets.VAPE_PEN, CCUtils.asset("ecig-101/vape-pen.png"), 648, 62)
    game.load.spritesheet(Ecig101Assets.MATCH, CCUtils.asset("ecig-101/match.png"), 36, 207)
    game.load.spritesheet(Ecig101Assets.LIGHTABLE_CIGARETTE, CCUtils.asset("ecig-101/lightable-cigarette.png"), 399, 385)
    game.load.spritesheet(Ecig101Assets.VAPE_MOD, CCUtils.asset("ecig-101/vape-mod.png"), 151, 457)

    game.load.audio(Ecig101Assets.INTRO_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n1.mp3"))
    game.load.audio(Ecig101Assets.MOUTH_PIECE_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n2.mp3"))
    game.load.audio(Ecig101Assets.CARTRIDGE_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n3.mp3"))
    game.load.audio(Ecig101Assets.HEATING_ELEMENT_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n4.mp3"))
    game.load.audio(Ecig101Assets.BATTERY_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n5.mp3"))
    game.load.audio(Ecig101Assets.ECIG_POWER_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n6.mp3"))
    game.load.audio(Ecig101Assets.ECIG_POWER_AUDIO_6TH, CCUtils.asset("ecig-101/audio/ecig101-n6-6th.mp3"))
    game.load.audio(Ecig101Assets.ELIQUIDS_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n7.mp3"))
    game.load.audio(Ecig101Assets.ELIQUIDS_AUDIO_6TH, CCUtils.asset("ecig-101/audio/ecig101-n7-6th.mp3"))
    game.load.audio(Ecig101Assets.EXIT_AUDIO, CCUtils.asset("ecig-101/audio/ecig101-n-outro.mp3"))

}
